export default __webpack_public_path__ + "static/media/kitchen5-beforeC-1024w.dbba9ad9.webp";